import { fromJS } from 'immutable';
import { mergeEntity, normalizeEntities } from 'helpers/utilHelpers';

import {
  DELETE_SERVICE_SUCCESS,
  LOAD_SERVICES_SUCCESS,
  UPDATE_SERVICE_SUCCESS,
  CLEAR_SERVICES,
} from 'constants/ActionTypes';

const initialState = fromJS({
  services: {},
});

const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SERVICES_SUCCESS:
      return state.set('services', normalizeEntities(action.services.items, 'serviceId'));
    case CLEAR_SERVICES: {
      return state.set('services', initialState.get('services'));
    }
    case UPDATE_SERVICE_SUCCESS: {
      const service = { ...action.service };
      return state.setIn(
        ['services', service.serviceId],
        mergeEntity(service, state.getIn(['services', service.serviceId])),
      );
    }
    case DELETE_SERVICE_SUCCESS:
      return state.deleteIn(['services', action.serviceId]);
    default:
      return state;
  }
};

export default serviceReducer;
